module.exports = __webpack_public_path__ + "img/익선동 피자.b383541e.png";